const state = {
  updateFileCnt: null,
  privateList: [],
  privateAreaInfo: {
    groupId: null,
    groupName: null
  },
  coGroupList: [],
  coAreaInfo: {
    groupId: null,
    groupName: null
  }
};
const actions = {};
const mutations = {
  setUpdateCount(state, payload) {
    state.updateFileCnt = payload.updateFileCnt;
  },
  setPrivateList(state, payload) {
    state.privateList = payload.contentsList;
    state.privateAreaInfo.groupId = payload.groupId;
    state.privateAreaInfo.groupName = payload.groupName;
  },
  setCoList(state, payload) {
    state.coGroupList = payload;
  }
};
const getters = {};

export default { state, actions, mutations, getters, namespaced: true };



// WEBPACK FOOTER //
// ./src/js/store/modules/home.js